import { Api } from "@/@core"

const api = new Api("orchestrate/");

export class RestService {


  public static async downloadFile(nihdi: string, runNbr: number, runPeriod: string, applicationType: string, template: string) {
    return (await api.get(
      `patient`,
      { nihdi, runNbr, runPeriod, template },
      { accept: `application/${applicationType}`},
      { responseType: `blob` }
    )).data;
  }
}